var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "deposit detail" },
    [
      _vm.lang == _vm.$config.LANG_KOR
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(0),
                _vm._m(1),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(2),
                      _vm._m(3)
                    ])
                  : _vm._e()
              ]),
              _vm._m(4)
            ])
          ]
        : _vm.lang == _vm.$config.LANG_ENG
        ? [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(5),
                _vm._m(6),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(7),
                      _vm._m(8)
                    ])
                  : _vm._e()
              ]),
              _vm._m(9)
            ])
          ]
        : [
            _c("div", { staticClass: "scroll" }, [
              _c("article", { staticClass: "content-header bg-type" }, [
                _vm._m(10),
                _vm._m(11),
                true
                  ? _c("div", { staticClass: "summary" }, [
                      _vm._m(12),
                      _vm._m(13)
                    ])
                  : _vm._e()
              ]),
              _vm._m(14)
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("기업보통예금")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(" 일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금 ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")]),
        _c("span", { staticClass: "text" }, [_vm._v("연 ")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.00% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("VND")]),
        _c("span", { staticClass: "text" }, [_vm._v("연 ")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.10% ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("상품유형")]),
        _c("dd", [_vm._v("보통예금")]),
        _c("dt", [_vm._v("상품개요")]),
        _c("dd", [
          _vm._v("일시적 여유자금 보관목적의 입금 및 출금이 자유로운 예금")
        ]),
        _c("dt", [_vm._v("가입대상")]),
        _c("dd", [
          _vm._v("베트남 또는 외국 법령에 따라 설립되고 운영되는 법인")
        ]),
        _c("dt", [_vm._v("계약기간")]),
        _c("dd", [_vm._v("제한없음")]),
        _c("dt", [_vm._v("가입통화")]),
        _c("dd", [_vm._v("VND, USD")]),
        _c("dt", [_vm._v("가입금액")]),
        _c("dd", [_vm._v("제한없음")]),
        _c("dt", [_vm._v("금리 및 이율")]),
        _c("dd", [_vm._v("약정이율 : USD 연 0.00%, VND 연 0.10%")]),
        _c("dt", [_vm._v("수수료")]),
        _c("dd", [_vm._v("해당무")]),
        _c("dt", [_vm._v("가입방법")]),
        _c("dd", [_vm._v("영업점가입")]),
        _c("dt", [_vm._v("가입시 필요서류")]),
        _c("dd", [
          _vm._v(" · 법적 설립 근거를 증명할수 있는 설립인가서나 법적서류"),
          _c("br"),
          _vm._v(
            " · 회사를 대표하여 법적으로 권리를 행상할 수 있는 대표자를 확인해주는 서류"
          ),
          _c("br"),
          _vm._v(" · 대표자의 공인 신분증 혹은 여권 및 서명 표본"),
          _c("br"),
          _vm._v(" · 대표자의 위임장(대표자외 다른 사람이 예금주가 되는 경우)"),
          _c("br"),
          _vm._v(
            " · 수임인의 서명 등록 및 계좌관리범위(대표자외 다른 사람이 예금주가 되는 경우)"
          ),
          _c("br"),
          _vm._v(
            " · 수임인의 공인신분증 혹은 여권 및 서명표본(대표자와 다른 사람이 예금주가 되는 경우) "
          )
        ]),
        _c("dt", [_vm._v("유의사항 및 기타")]),
        _c("dd", [_vm._v("최소유지 잔액 USD 10.00")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("BUSINESS CURRENT ACCOUNT")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          " Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.00% annually ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item item-row" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("VND")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.10% annually ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Types")]),
        _c("dd", [_vm._v("Current Account")]),
        _c("dt", [_vm._v("About the products")]),
        _c("dd", [
          _vm._v(
            "Savings that can deposit and withdraw money freely for an archival purpose of a temporary surplus funds"
          )
        ]),
        _c("dt", [_vm._v("Eligibilty")]),
        _c("dd", [
          _vm._v(
            "The Corporation that is established and operated in accordance with the laws and regulations of Vietnamese or foreign country"
          )
        ]),
        _c("dt", [_vm._v("Contract Terms")]),
        _c("dd", [_vm._v("No restrictions")]),
        _c("dt", [_vm._v("Available currency")]),
        _c("dd", [_vm._v("VND, USD")]),
        _c("dt", [_vm._v("Deposit amount")]),
        _c("dd", [_vm._v("No restrictions")]),
        _c("dt", [_vm._v("Loan Rate")]),
        _c("dd", [
          _vm._v(
            "Agreed interest rate : USD 0.00% annually , VND 0.10% annually"
          )
        ]),
        _c("dt", [_vm._v("Fees")]),
        _c("dd", [_vm._v("N/A")]),
        _c("dt", [_vm._v("How to apply")]),
        _c("dd", [_vm._v("Apply at the branch")]),
        _c("dt", [_vm._v("Required documents for application")]),
        _c("dd", [
          _vm._v(
            " -Business license or legal documents to prove the legality of the company"
          ),
          _c("br"),
          _vm._v(
            " -Documents to confirm the representative who can exercise the rights of the company"
          ),
          _c("br"),
          _vm._v(" -Representative's official ID, passport or signed copy"),
          _c("br"),
          _vm._v(
            " -Representative's letter of attorney (if the account holder is not the representative)"
          ),
          _c("br"),
          _vm._v(
            " -Delegated person's range of account management and registration of his/her signature (if the account holder is not the representative)"
          ),
          _c("br"),
          _vm._v(
            " -Delegated person's ID, passport or signed copy (If the account holder is not the representative) "
          )
        ]),
        _c("dt", [_vm._v("Notices and others")]),
        _c("dd", [_vm._v("Minimum balance to maintain : USD 10.00")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Tiền gửi thanh toán doanh nghiệp")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", [
        _vm._v(
          " Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("USD")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.00%/năm ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item" }, [
      _c("div", { staticClass: "tit" }, [
        _c("span", { staticClass: "exchange-unit" }, [_vm._v("VND")])
      ]),
      _c("div", { staticClass: "percent" }, [_vm._v(" 0.10% /năm ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", { staticClass: "contents" }, [
      _c("dl", { staticClass: "dlist dlist-item--type5" }, [
        _c("dt", [_vm._v("Hình thức sản phẩm")]),
        _c("dd", [_vm._v("Tiền gửi thông thường")]),
        _c("dt", [_vm._v("Giới thiệu sản phẩm")]),
        _c("dd", [
          _vm._v(
            "Là hình thức tiền gửi mà quý khách có thể tự do nạp và rút tiền mà không cần phải ấn định thời gian"
          )
        ]),
        _c("dt", [_vm._v("Đối tượng gia nhập")]),
        _c("dd", [
          _vm._v(
            "Pháp nhân được thành lập và hoạt động theo pháp luật Việt Nam hoặc pháp luật nước ngoài"
          )
        ]),
        _c("dt", [_vm._v("Thời gian hợp đồng")]),
        _c("dd", [_vm._v("Không giới hạn")]),
        _c("dt", [_vm._v("Loại tiền tệ gia nhập")]),
        _c("dd", [_vm._v("VND, USD")]),
        _c("dt", [_vm._v("Số tiền gia nhập")]),
        _c("dd", [_vm._v("Không giới hạn")]),
        _c("dt", [_vm._v("Lãi suất")]),
        _c("dd", [
          _vm._v("Lãi suất cam kế t: USD 0.00% một năm, VND 0.10% một năm")
        ]),
        _c("dt", [_vm._v("Biểu phí")]),
        _c("dd", [_vm._v("Không có nội dung tương ứng")]),
        _c("dt", [_vm._v("Cách thức gia nhập")]),
        _c("dd", [_vm._v("Tham gia chi nhánh")]),
        _c("dt", [_vm._v("Giấy tờ cần thiết khi gia nhập")]),
        _c("dd", [
          _vm._v(
            " - Giấy phép thành lập hoặc hồ sơ pháp lý chứng minh việc thành lập hợp pháp."
          ),
          _c("br"),
          _vm._v(
            " - Tài liệu chứng minh người đại diện có thể ủy quyền pháp lý đại diện cho công ty."
          ),
          _c("br"),
          _vm._v(
            " - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người đại diện."
          ),
          _c("br"),
          _vm._v(
            " - Giấy ủy quyền của người đại diện ( trường hợp không phải là người đại diện gửi tiền )"
          ),
          _c("br"),
          _vm._v(
            " - Đăng ký chữ ký của người được ủy quyền, phạm vi quản lý tài khoản ( trường hợp không phải là người đại diện gửi tiền )"
          ),
          _c("br"),
          _vm._v(
            " - CMND hoặc hộ chiếu hoặc mẫu chữ ký công chứng của người được ủy quyền ( trường hợp không phải là người đại diện gửi tiền ) "
          )
        ]),
        _c("dt", [_vm._v("Lưu ý")]),
        _c("dd", [_vm._v("Số dư tối thiểu để duy trì tài khoản 10.00 USD")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }